import ema from "./ema";
import { zipper } from "../utils";
import { DEMA as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  const calculator = (data) => {
    const ema1 = ema().options({
      windowSize: options.windowSize,
      sourcePath: options.sourcePath,
    });
    const ema1Result = ema1(data);

    // Prepare data for EMA2 (EMA of EMA1)
    const ema1Data = data.map((d, i) => ({
      ...d,
      ema1: ema1Result[i],
    }));

    const ema2 = ema().options({
      windowSize: options.windowSize,
      sourcePath: "ema1",
    });
    const ema2Result = ema2(ema1Data);

    // DEMA = 2 * EMA1 - EMA2
    return zipper().combine((e1, e2) =>
      e1 !== undefined && e2 !== undefined ? 2 * e1 - e2 : undefined,
    )(ema1Result, ema2Result);
  };

  calculator.options = (newOptions) => {
    if (!newOptions) return options;
    options = { ...options, ...newOptions };
    return calculator;
  };

  calculator.undefinedLength = () => 2 * (options.windowSize - 1);

  return calculator;
}
